import {
  Button,
  CircularProgress,
  Popover,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  Link,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from '@mui/material';
import { MouseEvent, useEffect, useState } from 'react';
import { Warehouse } from '../../store/config/types/warehouses.types';

export interface WarehouseEditLinkProps {
  warehouseId?: number;
  warehouses?: Warehouse[];
  dialogTitle?: string;
  disabled?: boolean;
  // eslint-disable-next-line
  onSubmit?: (warehouseId?: number) => void;
}
export default function WarehouseEditLink({
  warehouseId,
  warehouses,
  onSubmit,
  dialogTitle,
  disabled,
}: WarehouseEditLinkProps) {
  const [selectedWarehouseId, setSelectedWarehouseId] = useState(warehouseId);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  useEffect(() => {
    setSelectedWarehouseId(warehouseId);
  }, [warehouseId]);

  const handleChange = () => {
    const newWarehouseId = selectedWarehouseId;
    if (onSubmit && selectedWarehouseId) {
      onSubmit(newWarehouseId);
    }
    handleClose();
  };

  function handleChangeWarehouse(event: SelectChangeEvent<number>) {
    setSelectedWarehouseId(+event.target.value);
  }

  function handleOpenPopover(event: MouseEvent<HTMLElement>) {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setSelectedWarehouseId(warehouseId);
    setAnchorEl(null);
  }

  const openPopover = Boolean(anchorEl);

  function getWarehouseName(selectedWarehouseId: number | undefined) {
    return warehouses?.find((w) => w.warehouseId === selectedWarehouseId)?.name ?? 'No warehouse selected';
  }

  return (
    <>
      <Link onClick={disabled ? undefined : handleOpenPopover} sx={{ cursor: 'pointer' }}>
        <Typography variant="subtitle1" color={!warehouseId ? 'gray' : disabled ? 'black' : undefined}>
          {warehouseId ? getWarehouseName(warehouseId) : 'Select a warehouse'}
        </Typography>
      </Link>

      <Popover
        open={openPopover}
        anchorEl={anchorEl}
        onClick={(e) => e.stopPropagation()}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <DialogTitle>
          <Typography variant="subtitle2">{dialogTitle ?? `Change Warehouse`} </Typography>
        </DialogTitle>
        <DialogContent>
          <Grid container pt={2} flexDirection={'column'} gap={1}>
            {warehouses?.length && (
              <Grid>
                <FormControl fullWidth>
                  <InputLabel id="warehouse-select-label">Warehouse</InputLabel>
                  <Select
                    labelId="warehouse-select-label"
                    value={selectedWarehouseId}
                    label="Warehouse"
                    onChange={handleChangeWarehouse}
                  >
                    {warehouses?.map((warehouse) => (
                      <MenuItem key={warehouse.warehouseId} value={warehouse.warehouseId}>
                        {warehouse.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container>
            <Grid item flexGrow={1} pl={2}>
              {disabled && <CircularProgress size={32} />}
            </Grid>
            <Grid item>
              <Button variant="text" color="error" onClick={handleClose} disabled={disabled}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="success"
                disabled={disabled || !selectedWarehouseId}
                onClick={handleChange}
              >
                Change
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Popover>
    </>
  );
}
